import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // sets '_destroy' input to '1' and hides `form-field`
  mark (e) {
    e.preventDefault()

    const wrapper = e.target.closest("fieldset")

    // to override `d-flex`, `d-block`, etc.
    wrapper.classList.add("d-none")

    const input = wrapper.querySelector("input[name*='_destroy']")
    input.value = "1"

    // to trigger setting positionsk
    // OPTODO: display toast with option to undo
    wrapper.insertAdjacentHTML('beforebegin', `
      <span class="d-none">🗑️↓</span>
    `)
  }
}
